import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

const Home = () => {

    const navigate = useNavigate(); // Add this

    const scrollToSection = (sectionId) => {
        navigate('/how-it-works'); // Go to HowItWorks page
        setTimeout(() => {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100); // Small delay for page load
    };
    return (
        <>
            {/* HERO SECTION (Existing) */}
            <section className="hero-section position-relative">
                <div className="container">

                    <h1>Shopy Sync: Shopify Data Bulk Tool</h1>
                    <p>
                        Import, export, update, and delete your store products using <strong>Google Sheets</strong>.
                    </p>
                    <button className="btn install-btn px-5 py-3 mt-4"
                            onClick={() => window.location.href = 'https://apps.shopify.com/'}
                    >
                        Install App
                    </button>
                </div>
            </section>


            <section className="py-5 bg-white mt-5">
                <div className="container text-center">
                    <img
                        src="images/ShopifyApp.png"
                        alt="Shopify Plus, Shopify, Built for Shopify"
                        className="img-fluid"
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            maxHeight: '80px',
                            objectFit: 'contain'
                        }}
                    />
                </div>
            </section>

            <section className="py-5 bg-light mt-5">
                <div className="container">
                    {/* Section title – matches Matrixify style */}
                    <h2 className="text-center mb-5 fw-bold text-teal">
                        Shopy Sync – Bulk Product Data Management
                    </h2>


                    <div className="row g-4 justify-content-center">

                        {/* ==== 1. EXPORT TO XLSX ==== */}
                        <div className="col-lg-3 col-md-6">
                            <div className="card h-100 border-0 shadow-sm text-center p-4 feature-card"
                                style={{ cursor: 'pointer' }}
                                onClick={() => scrollToSection('export')}
                            >
                                <div className="card-body">
                                    <div className="feature-icon mb-3">
                                        <i className="fas fa-file-excel fa-3x"></i>
                                    </div>
                                    <h5 className="fw-bold">Export to Google Sheets</h5>
                                    <p className="text-muted small">
                                        Export all products with variants, inventory, price & media in a single, ready-to-edit <strong>Google Sheets</strong>.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* ==== 2. BULK CREATE WITH VARIANTS ==== */}
                        <div className="col-lg-3 col-md-6">
                            <div className="card h-100 border-0 shadow-sm text-center p-4 feature-card"
                                style={{ cursor: 'pointer' }}
                                onClick={() => scrollToSection('bulk-add')}
                            >
                                <div className="card-body">
                                    <div className="feature-icon mb-3">
                                        <i className="fas fa-plus-square fa-3x"></i>
                                    </div>
                                    <h5 className="fw-bold">Bulk Create Products</h5>
                                    <p className="text-muted small">
                                        Add new products with multiple variant options, images & inventory directly from your <strong>Google Sheets</strong> in one go.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* ==== 3. BULK UPDATE ==== */}
                        <div className="col-lg-3 col-md-6">
                            <div className="card h-100 border-0 shadow-sm text-center p-4 feature-card"
                                style={{ cursor: 'pointer' }}
                                onClick={() => scrollToSection('bulk-update')}
                            >
                                <div className="card-body">
                                    <div className="feature-icon mb-3">
                                        <i className="fas fa-edit fa-3x"></i>
                                    </div>
                                    <h5 className="fw-bold">Bulk Update Products</h5>
                                    <p className="text-muted small">
                                        Update variants, inventory, pricing & media for thousands of products in one upload – no re-import required.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* ==== 4. BULK DELETE (Shopify ↔ Sheet) ==== */}
                        <div className="col-lg-3 col-md-6">
                            <div className="card h-100 border-0 shadow-sm text-center p-4 feature-card"
                                style={{ cursor: 'pointer' }}
                                onClick={() => scrollToSection('bulk-delete-shopify')}
                            >
                                <div className="card-body">
                                    <div className="feature-icon mb-3">
                                        <i className="fas fa-trash-alt fa-3x"></i>
                                    </div>
                                    <h5 className="fw-bold">Bulk Delete (Two-Way)</h5>
                                    <p className="text-muted small">
                                        Delete products in Shopify → automatically removed from your sheet, or delete rows in the sheet → instantly removed from Shopify.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

        </>
    );
};

export default Home;